
const localStorageContents = localStorage.getItem('NucleusXP');
const localStorageData = JSON.parse(localStorageContents) || {};

/**
 * A utility object for managing default application settings and synchronizing them with localStorage.
 */
const defaults = {
  /**
   * @property {Array} tenants - The list of tenants loaded from localStorage.
   * Defaults to an empty array if no data is found.
   */
  tenants: localStorageData.t || [],

  /**
   * @property {number} currentTenantIndex - The index of the current tenant loaded from localStorage.
   * Defaults to 0 if no data is found.
   */
  currentTenantIndex: localStorageData.i || 0,

  /**
   * Updates the localStorage with the current state of tenants.
   *
   * @param {Tenants} tenants - An instance of the `Tenants` class.
   * The method retrieves tenant data and the current index, then stores them in localStorage.
   */
  update(tenants) {
    localStorage.setItem('NucleusXP', JSON.stringify({
      t: tenants.get(),
      i: tenants.getCurrentIndex()
    }))
  }
};

export default defaults;